module.exports = __webpack_public_path__ + "static/img/logo1.140ead78.png";